var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"d-flex elevation-0 "},[_c('div',{staticClass:"pl-0 d-flex header-icon",attrs:{"elevation":"0"}},[_c('v-icon',{staticClass:"icon reloj"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }